import { defineSemanticTokens, defineTokens } from '@pandacss/dev'

const tokens = defineTokens.colors({
  light: {
    '1': { value: '#fffcfe' },
    '2': { value: '#fef7fb' },
    '3': { value: '#fee9f5' },
    '4': { value: '#fbdcef' },
    '5': { value: '#f6cee7' },
    '6': { value: '#efbfdd' },
    '7': { value: '#e7acd0' },
    '8': { value: '#dd93c2' },
    '9': { value: '#d6409f' },
    '10': { value: '#cf3897' },
    '11': { value: '#c2298a' },
    '12': { value: '#651249' },
    a1: { value: '#ff00aa03' },
    a2: { value: '#e0008008' },
    a3: { value: '#f4008c16' },
    a4: { value: '#e2008b23' },
    a5: { value: '#d1008331' },
    a6: { value: '#c0007840' },
    a7: { value: '#b6006f53' },
    a8: { value: '#af006f6c' },
    a9: { value: '#c8007fbf' },
    a10: { value: '#c2007ac7' },
    a11: { value: '#b60074d6' },
    a12: { value: '#59003bed' },
  },
  dark: {
    '1': { value: '#191117' },
    '2': { value: '#21121d' },
    '3': { value: '#37172f' },
    '4': { value: '#4b143d' },
    '5': { value: '#591c47' },
    '6': { value: '#692955' },
    '7': { value: '#833869' },
    '8': { value: '#a84885' },
    '9': { value: '#d6409f' },
    '10': { value: '#de51a8' },
    '11': { value: '#ff8dcc' },
    '12': { value: '#fdd1ea' },
    a1: { value: '#f412bc09' },
    a2: { value: '#f420bb12' },
    a3: { value: '#fe37cc29' },
    a4: { value: '#fc1ec43f' },
    a5: { value: '#fd35c24e' },
    a6: { value: '#fd51c75f' },
    a7: { value: '#fd62c87b' },
    a8: { value: '#ff68c8a2' },
    a9: { value: '#fe49bcd4' },
    a10: { value: '#ff5cc0dc' },
    a11: { value: '#ff8dcc' },
    a12: { value: '#ffd3ecfd' },
  },
})
const semanticTokens = defineSemanticTokens.colors({
  '1': { value: { _light: '{colors.pink.light.1}', _dark: '{colors.pink.dark.1}' } },
  '2': { value: { _light: '{colors.pink.light.2}', _dark: '{colors.pink.dark.2}' } },
  '3': { value: { _light: '{colors.pink.light.3}', _dark: '{colors.pink.dark.3}' } },
  '4': { value: { _light: '{colors.pink.light.4}', _dark: '{colors.pink.dark.4}' } },
  '5': { value: { _light: '{colors.pink.light.5}', _dark: '{colors.pink.dark.5}' } },
  '6': { value: { _light: '{colors.pink.light.6}', _dark: '{colors.pink.dark.6}' } },
  '7': { value: { _light: '{colors.pink.light.7}', _dark: '{colors.pink.dark.7}' } },
  '8': { value: { _light: '{colors.pink.light.8}', _dark: '{colors.pink.dark.8}' } },
  '9': { value: { _light: '{colors.pink.light.9}', _dark: '{colors.pink.dark.9}' } },
  '10': { value: { _light: '{colors.pink.light.10}', _dark: '{colors.pink.dark.10}' } },
  '11': { value: { _light: '{colors.pink.light.11}', _dark: '{colors.pink.dark.11}' } },
  '12': { value: { _light: '{colors.pink.light.12}', _dark: '{colors.pink.dark.12}' } },
  a1: { value: { _light: '{colors.pink.light.a1}', _dark: '{colors.pink.dark.a1}' } },
  a2: { value: { _light: '{colors.pink.light.a2}', _dark: '{colors.pink.dark.a2}' } },
  a3: { value: { _light: '{colors.pink.light.a3}', _dark: '{colors.pink.dark.a3}' } },
  a4: { value: { _light: '{colors.pink.light.a4}', _dark: '{colors.pink.dark.a4}' } },
  a5: { value: { _light: '{colors.pink.light.a5}', _dark: '{colors.pink.dark.a5}' } },
  a6: { value: { _light: '{colors.pink.light.a6}', _dark: '{colors.pink.dark.a6}' } },
  a7: { value: { _light: '{colors.pink.light.a7}', _dark: '{colors.pink.dark.a7}' } },
  a8: { value: { _light: '{colors.pink.light.a8}', _dark: '{colors.pink.dark.a8}' } },
  a9: { value: { _light: '{colors.pink.light.a9}', _dark: '{colors.pink.dark.a9}' } },
  a10: { value: { _light: '{colors.pink.light.a10}', _dark: '{colors.pink.dark.a10}' } },
  a11: { value: { _light: '{colors.pink.light.a11}', _dark: '{colors.pink.dark.a11}' } },
  a12: { value: { _light: '{colors.pink.light.a12}', _dark: '{colors.pink.dark.a12}' } },
  default: { value: { _light: '{colors.pink.light.9}', _dark: '{colors.pink.dark.9}' } },
  emphasized: { value: { _light: '{colors.pink.light.10}', _dark: '{colors.pink.dark.10}' } },
  fg: { value: { _light: 'white', _dark: 'white' } },
  text: { value: { _light: '{colors.pink.light.a11}', _dark: '{colors.pink.dark.a11}' } },
})

export default {
  name: 'pink',
  tokens,
  semanticTokens,
}
